<div class="triangle" #triangle>
  <img [src]=img
    (load)="updatePoint()"
    (click)="movePoint($event)"
  />
  <div class="point" #point></div>
</div>
